import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { SvgIcon } from './SvgIcon';
import { getTranslation } from '../utils/translations';

export const FilterButton = ({ onChange }) => {
    const [areFilterOptionsVisible, setAreFilterOptionsVisible] =
        useState(false);

    useEffect(() => {
        onChange(areFilterOptionsVisible);
    }, [areFilterOptionsVisible]);

    return (
        <button
            className={classNames('filter-button', {
                'filter-button--active': areFilterOptionsVisible
            })}
            onClick={() => {
                setAreFilterOptionsVisible((prev) => !prev);
            }}
        >
            <SvgIcon icon="filter-circle" className="filter-button__icon" />
            <SvgIcon
                icon="filter-circle-fill"
                className="filter-button__icon-active"
            />
            {getTranslation('label.statsLeaders.filters.toggleButtonText')}
        </button>
    );
};

FilterButton.propTypes = {
    onChange: PropTypes.func.isRequired
};
